module.exports = __webpack_public_path__ + "img/characters.ff03cbd7.png";